import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AccountPostingType } from './account-posting-type.model';

export const loadAccountPostingTypes = createAction(
    '[AccountPostingType/API] Load AccountPostingTypes',
    props<{ AccountPostingTypes: AccountPostingType[] }>()
);

export const addAccountPostingType = createAction(
    '[AccountPostingType/API] Add AccountPostingType',
    props<{ AccountPostingType: AccountPostingType }>()
);

export const upsertAccountPostingType = createAction(
    '[AccountPostingType/API] Upsert AccountPostingType',
    props<{ AccountPostingType: AccountPostingType }>()
);

export const addAccountPostingTypes = createAction(
    '[AccountPostingType/API] Add AccountPostingTypes',
    props<{ AccountPostingTypes: AccountPostingType[] }>()
);

export const upsertAccountPostingTypes = createAction(
    '[AccountPostingType/API] Upsert AccountPostingTypes',
    props<{ AccountPostingTypes: AccountPostingType[] }>()
);

export const updateAccountPostingType = createAction(
    '[AccountPostingType/API] Update AccountPostingType',
    props<{ AccountPostingType: Update<AccountPostingType> }>()
);

export const updateAccountPostingTypes = createAction(
    '[AccountPostingType/API] Update AccountPostingTypes',
    props<{ AccountPostingTypes: Update<AccountPostingType>[] }>()
);

export const deleteAccountPostingType = createAction(
    '[AccountPostingType/API] Delete AccountPostingType',
    props<{ id: string }>()
);

export const deleteAccountPostingTypes = createAction(
    '[AccountPostingType/API] Delete AccountPostingTypes',
    props<{ ids: string[] }>()
);

export const clearAccountPostingTypes = createAction(
    '[AccountPostingType/API] Clear AccountPostingTypes'
);

export const getAccountPostingTypes = createAction(
    '[Account/API] Get Account Posting Types'
);
export const putAccountPostingTypes = createAction(
    '[Account/API] Put Account Posting Types',
    props<{ AccountPostingTypes: AccountPostingType[] }>()
);
